import { Link } from 'react-router-dom';

export default function CTAReframing() {
  const handlePrint = () => {
    window.print();
  };

  const handleSave = () => {
    const reframingData = localStorage.getItem('worksheet-reframing');
    const compromissoData = localStorage.getItem('compromisso-reframing');
    
    const data = {
      worksheet: reframingData ? JSON.parse(reframingData) : null,
      compromisso: compromissoData ? JSON.parse(compromissoData) : null,
      dataExportacao: new Date().toISOString()
    };

    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `worksheet-reframing-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <section className="py-16 bg-gradient-to-br from-purple-50 via-pink-50 to-rose-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Continue Sua Jornada de Transformação
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore outros exercícios de PNL que complementam a técnica de Ressignificação
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <Link
            to="/worksheet-swish"
            className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 group"
          >
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <i className="ri-flashlight-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Técnica Swish</h3>
            <p className="text-gray-600 mb-4">
              Substitua padrões mentais indesejados rapidamente
            </p>
            <span className="text-purple-600 font-semibold flex items-center gap-2 group-hover:gap-3 transition-all">
              Praticar agora
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>

          <Link
            to="/exercicio/linha-tempo-pnl"
            className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 group"
          >
            <div className="w-14 h-14 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <i className="ri-time-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Linha do Tempo</h3>
            <p className="text-gray-600 mb-4">
              Libere emoções negativas do passado
            </p>
            <span className="text-purple-600 font-semibold flex items-center gap-2 group-hover:gap-3 transition-all">
              Ver detalhes
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>

          <Link
            to="/exercicio/ancoragem-emocional-pnl"
            className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 group"
          >
            <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <i className="ri-anchor-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Ancoragem Emocional</h3>
            <p className="text-gray-600 mb-4">
              Crie gatilhos instantâneos para estados positivos
            </p>
            <span className="text-purple-600 font-semibold flex items-center gap-2 group-hover:gap-3 transition-all">
              Ver detalhes
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/planos#exercicios-pnl"
            className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-grid-line text-xl"></i>
            Ver Todos os Exercícios
          </Link>

          <button
            onClick={handlePrint}
            className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold text-lg hover:shadow-lg transition-all duration-300 border-2 border-purple-200 whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-printer-line text-xl"></i>
            Imprimir Worksheet
          </button>
        </div>

        <button
          onClick={handleSave}
          className="fixed bottom-8 right-8 w-14 h-14 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center z-40"
          title="Salvar worksheet"
        >
          <i className="ri-save-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}